import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import {
  Button,
  LoadingIcon,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  SidebarFooter,
  Text,
} from '../../../../../../UILibrary';
import { definedTranslation } from '../../i18n';

type RequestQuoteSubmitSectionProps = {
  isLearnMoreButtonDisabled?: boolean;
  isSubmitButtonDisabled?: boolean;
  isCreateOrderLoading?: boolean;
  errorTooltipContent: ReactNode;
  errorMessage: string;
  onLearnMoreClick?: () => void;
  onSubmit: () => void;
};

export function RequestQuoteSubmitSection({
  isLearnMoreButtonDisabled = false,
  isSubmitButtonDisabled = false,
  isCreateOrderLoading = false,
  errorTooltipContent,
  errorMessage,
  onLearnMoreClick,
  onSubmit,
}: RequestQuoteSubmitSectionProps) {
  const intl = useIntl();

  return (
    <>
      {errorMessage ? (
        <Text variant="Body" className="px-6 text-red">
          {errorMessage}
        </Text>
      ) : null}
      <SidebarFooter>
        <div className="w-full flex gap-2">
          <Button
            className="w-full"
            disabled={isLearnMoreButtonDisabled}
            onClick={onLearnMoreClick}
          >
            {intl?.formatMessage(definedTranslation.requestQuote.learnMoreBtn)}
          </Button>

          <Tooltip>
            <TooltipTrigger
              disableHover={!isSubmitButtonDisabled}
              className="w-full"
            >
              <Button
                variant="primary"
                className="w-full"
                disabled={isSubmitButtonDisabled}
                onClick={onSubmit}
              >
                {isCreateOrderLoading ? (
                  <LoadingIcon />
                ) : (
                  intl?.formatMessage(
                    definedTranslation.requestQuote.submitRequestBtn,
                  )
                )}
              </Button>
            </TooltipTrigger>
            <TooltipContent>{errorTooltipContent}</TooltipContent>
          </Tooltip>
        </div>
      </SidebarFooter>
    </>
  );
}
